import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Close from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';
import * as React from 'react';

interface IDialogAppBarProps {
  onCloseClick: () => void;
  buttonDisabled?: boolean;
  onButtonClick?: () => void;
  title: React.ReactNode;
  buttonText?: string;
  iconButton?: boolean;
  hideButton?: boolean;
  actionIcon?: React.ComponentType<SvgIconProps>;
  children?: React.ReactNode;
  secondaryText?: React.ReactNode;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      //marginBottom: theme.spacing(2),
      paddingLeft: theme.spacing(),
      paddingRight: theme.spacing()
    },
    flex: {
      flex: 1
    },
    root: {
      flexGrow: 1
    }
  })
);

let DialogAppBar: React.FunctionComponent<IDialogAppBarProps> = ({
  children,
  buttonDisabled,
  buttonText = 'Save',
  hideButton,
  iconButton = true,
  onButtonClick,
  onCloseClick,
  title,
  secondaryText,
  ...props
}) => {
  const classes = useStyles();
  const handleCloseClick = React.useCallback(() => onCloseClick(), [onCloseClick]);

  return (
    <AppBar position="static" className={classes.appBar}>
      <Toolbar disableGutters>
        <IconButton onClick={handleCloseClick} color="inherit">
          <Close />
        </IconButton>
        <div className={classes.root}>
          <Typography variant="h6" color="inherit">
            {title}
          </Typography>
          {secondaryText && (
            <Typography variant="body2" color="inherit">
              {secondaryText}
            </Typography>
          )}
        </div>
        {!hideButton && !children && (
          <>
            {iconButton ? (
              <IconButton color="inherit" onClick={onButtonClick} disabled={buttonDisabled}>
                {props.actionIcon ? <props.actionIcon /> : <SaveIcon />}
              </IconButton>
            ) : (
              <Button color="inherit" onClick={onButtonClick} disabled={buttonDisabled}>
                {buttonText}
              </Button>
            )}
          </>
        )}
        {children}
      </Toolbar>
    </AppBar>
  );
};

DialogAppBar = React.memo<IDialogAppBarProps>(DialogAppBar);
export { DialogAppBar };
